import { render, staticRenderFns } from "./UpdatesDetail.vue?vue&type=template&id=8aec2a5e&scoped=true"
import script from "./UpdatesDetail.vue?vue&type=script&lang=js"
export * from "./UpdatesDetail.vue?vue&type=script&lang=js"
import style0 from "./UpdatesDetail.vue?vue&type=style&index=0&id=8aec2a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aec2a5e",
  null
  
)

export default component.exports